import { useRef, useState, useEffect, useCallback } from 'react';
import Navbar from '../sections/navbar/Navbar';
import Header from '../sections/header/Header';
import About from '../sections/about/About';
import Services from '../sections/services/Services';
import Portfolio from '../sections/portfolio/Portfolio';
import Experience from '../sections/experience/Experience';
import Testimonials from '../sections/testimonials/Testimonials';
import Contact from '../sections/contact/Contact';
import Footer from '../sections/footer/Footer';
import FloatingNav from '../sections/floating-nav/FloatingNav';

const Home = () => {
  const mainRef = useRef();
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPostion, setSiteYPosition] = useState(0);

  const showFloatingNavHandler = () => setShowFloatingNav(true);
  const hideFloatingNavHandler = () => setShowFloatingNav(false);

  const floatingNavToggleHandler = useCallback(() => {
    if (
      siteYPostion < mainRef?.current?.getBoundingClientRect().y - 20 ||
      siteYPostion > mainRef?.current?.getBoundingClientRect().y + 20
    ) {
      showFloatingNavHandler();
    } else {
      hideFloatingNavHandler();
    }

    setSiteYPosition(mainRef?.current?.getBoundingClientRect().y);
  }, [siteYPostion, mainRef]);

  useEffect(() => {
    const checkYPosition = setInterval(floatingNavToggleHandler, 2000);
    return () => clearInterval(checkYPosition);
  }, [floatingNavToggleHandler]);

  return (
    <div ref={mainRef}>
      <Navbar />
      <Header />
      <About />
      <Services />
      <Portfolio />
      <Experience />
      <Testimonials />
      <Contact />
      <Footer />
      {showFloatingNav && <FloatingNav />}
    </div>
  );
};

export default Home;
